import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./NextThinkDevicesPopUp.css";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";
import { getNextThinkDeviceFixNowURL } from "../../../utils/constants";
import { appConfig } from "../../../../../../utils/app.config";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NextThinkDevicesPopUp: React.FC<{
  NextThinkData: any;
  setModalOpen: any;
  modalOpen: any;
}> = ({ NextThinkData, setModalOpen, modalOpen }) => {
  const theme = useTheme(); // Access the current theme
  const colors = tokens(theme.palette.mode);
  const redirectUrl: string = useSelector(
    (state: any) => state.headers.redirectUrl
  );

  let color = theme.palette.mode;
  const handleClose = () => setModalOpen(false);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  console.log("nextthink data", NextThinkData);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleItemClick = (index: any, device: any) => {
    setSelectedDevice(device);
    setActiveIndex(index);
  };

  const nextthinkFixNow = async () => {
    console.log("device", selectedDevice, NextThinkData[0].message);
    try {
      const options = {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          script: NextThinkData[0].message,
          deviceId: selectedDevice,
        }),
      };
      const result = await (
        await fetch(getNextThinkDeviceFixNowURL, options)
      ).json();
      if (result) {
        console.log("next think device fix now", result);
      }
    } catch (err: any) {
      console.log("ERROR :::", err);
    }
  };

  useEffect(() => {
    // Set CSS variables based on the current theme colors
    document.documentElement.style.setProperty(
      "--header-bg-color",
      colors.headers.backround
    );
    document.documentElement.style.setProperty(
      "--header-text-color",
      colors.headers.text
    );
    document.documentElement.style.setProperty(
      "--box-shadow",
      colors.headers.boxShadow
    );
  }, [theme]);

  return (
    <>
      <Modal
        show={modalOpen}
        onHide={handleClose}
        data-bs-theme={color}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // style={{padding: '0px !important'}}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        {/* <button

              style={{
                minWidth: "36px",
                width: "36px",
                height: "36px",
                borderRadius: "50px",
                color: "white",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}

              className='btn btn-link btn-icn'
              onClick={handleClose}
            >
              <i className="bi bi-x" style={{fontSize: '26px'}}></i>
              {/* <CloseRoundedIcon /> */}
        {/*</button> */}
        {/* </div> */}

        {NextThinkData.length === 0 ? (
          <>
            <Modal.Body style={{ margin: 0 }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  style={{ height: "90px" }}
                  src={appConfig.imagesUrl + "/desktop/loading.gif"}
                ></img>
              </div>
            </Modal.Body>
          </>
        ) : (
          <>
            <Modal.Body style={{ margin: 0 }}>
              {NextThinkData && NextThinkData.message ? (
                <>
                  <div className="script_success">
                    <div
                      style={{
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "20px",
                        height: "120px",
                        width: "120px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={appConfig.imagesUrl + "/desktop/success_icon.png"}
                      ></img>
                    </div>
                  </div>
                  <h5
                    style={{
                      color: "var(--header-text-color)",
                      marginBottom: "12px",
                      textAlign: "center",
                    }}
                  >
                    {NextThinkData.message}
                  </h5>
                </>
              ) : (
                <>
                  {NextThinkData.map((data: any) => (
                    <>
                      <h5
                        style={{
                          color: "var(--header-text-color)",
                          marginBottom: "12px",
                        }}
                      >
                        {data.message}
                      </h5>
                      <div style={{ position: "relative" }}>
                        <button
                          className="btn btn-primary"
                          style={{ padding: "8px 16px", cursor: "pointer" }}
                          onClick={toggleDropdown}
                        >
                          Select Device
                        </button>

                        {dropdownOpen && (
                          <ul className="nextthink-devices-ul">
                            {data.devices.map((device: any, index: any) => (
                              <li
                                style={{
                                  color: "var(--header-text-color)",
                                  padding: "8px 16px",
                                  cursor: "pointer",
                                  backgroundColor: "var(--header-bg-color)",
                                  boxShadow:
                                    activeIndex === index
                                      ? "var(--box-shadow)"
                                      : "",
                                }}
                                key={index}
                                onClick={() => handleItemClick(index, device)}
                              >
                                {device}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </>
                  ))}
                </>
              )}
            </Modal.Body>
          </>
        )}

        {NextThinkData.length === 0 ? <> </> : (
          <Modal.Footer style={{ justifyContent: "flex-end" }}>
            {NextThinkData && NextThinkData.message ? (
              <>
                <button
                  className="btn btn-primary"
                  style={{ width: "fit-content" }}
                  onClick={() => {
                    navigate(`${redirectUrl}/desktop`);
                  }}
                >
                  Okay
                </button>
              </>
            ) : (
              <>
                <button
                  disabled={activeIndex === null}
                  className="btn btn-primary"
                  style={{ width: "fit-content" }}
                  onClick={nextthinkFixNow}
                >
                  Fix Now
                </button>
              </>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};
export default NextThinkDevicesPopUp;
